import React, { FC } from "react";
import styled from "styled-components";
import { IRoadmap } from "@/shared/types/roadmap";
import useRoadmaps from "../../../../../pages/Map/hooks/useRoadmaps";
import img from "../../../../../assets/images/disabled1309.svg";

const Route: FC<IProps> = ({ route, isTram }) => {

    const { selectRoadmapByBusStation } = useRoadmaps();

    return (
        <Container onClick={() => selectRoadmapByBusStation(route, undefined, isTram ? 'ТРАМВАЙ' : 'АВТОБУС')}>
            <ContainerNumberAndName>
                <Number isTram={isTram}>{route.route_name}</Number>
                <Name>{route.route_full_name}</Name>
                {route.low_floor && route.low_floor === '1' &&
                    <DisabledImage src={img} alt="disabled" />}
            </ContainerNumberAndName>
            {route.rem_minutes &&
                <ContainerArrivalAndDepartureTime>
                    <ArrivalAndDepartureTime>{route.forecast_time_arrival ?? route.route_full_name.slice(0, 5)}</ArrivalAndDepartureTime>
                    <ArrivalMintes>{route.rem_minutes} {route.distance_to_stoppoint ? `(${route.distance_to_stoppoint} км)` : ''}</ArrivalMintes>
                </ContainerArrivalAndDepartureTime>
            }
        </Container>
    )
}

export default Route;

interface IProps {
    route: IRoadmap;
    isTram?: boolean
}

const Container = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    сursor: pointer;
    transition: background-color 0.7s;
    &:hover {
        background-color: rgba(0, 0, 0, 0.1); 
    }
`;

const ContainerNumberAndName = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

const Number = styled.p<{ isTram?: boolean }>`
    width: 55px;
    font-size: 15px;
    background-color:${({ isTram }) => (
        !isTram ? "#24CD73" : "#FF4D4D")};
    color: white;
    padding: 5px 12px;
    border-radius: 15px;
    margin:0 10px 0 0;
`;

const Name = styled.p`
    font-size: 15px;
    width: 220px;
    margin:0;
    margin-right:8px;
    text-align: left;
`;

const ArrivalAndDepartureTime = styled.p`
    width: 52px;
    margin:0;
    background-color:#F2F3F5;
    padding: 5px 12px;
    border-radius: 14px;
    font-weight: 500;
    font-size: 15px;
    `

const ArrivalMintes = styled.p<{ isTram?: boolean }>`
    font-size: 11px;
    margin:0;
    padding: 3px 0px 0px;
    border-radius: 14px;
    font-weight: 500;
    color: #24CD73;
    `

const ContainerArrivalAndDepartureTime = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    `

const DisabledImage = styled.img`
        width: 23px;
        height: 23px;
        margin-right: 10px;
    `